import keyBy from 'lodash/keyBy';

type TDictionaryId = string | number;

const findByKey = <T>(map: Record<string, T>, key?: TDictionaryId | null): T | undefined => {
  if (key === null || key === undefined) {
    return undefined;
  }

  return map[String(key)];
};

const createDictionaryAccessor = <T extends { id: TDictionaryId }>(items: T[]) => {
  const map = keyBy(items, (item) => String(item.id)) as Record<string, T>;

  return {
    getById: (id?: TDictionaryId | null) => findByKey(map, id),
    getAll: () => items,
    has: (id?: TDictionaryId | null) => findByKey(map, id) !== undefined,
  };
};

/**
 * Time zones are looked up both by dictionary id and by IANA name, because the
 * backend stores the user's preference as an IANA string (e.g. America/New_York)
 * while the UI keys its pickers on the dictionary id.
 */
export const createTimeZoneAccessor = <T extends { id: TDictionaryId, timeZone: string }>(items: T[]) => {
  const byTimeZone = keyBy(items, (item) => item.timeZone) as Record<string, T>;

  return {
    ...createDictionaryAccessor(items),
    getByTimeZone: (timeZone?: string | null) => findByKey(byTimeZone, timeZone),
  };
};

export default createDictionaryAccessor;
